import { render, staticRenderFns } from "./TextNext.vue?vue&type=template&id=6d52612e"
import script from "./TextNext.vue?vue&type=script&lang=js"
export * from "./TextNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports